// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1l3er","Open":"SideDrawer_Open__20_HD","Close":"SideDrawer_Close__2JUk4","Logo":"SideDrawer_Logo__qrhXT"};